import type { NotificationApiResponse } from '@/domains/notification/notification.entity';
import type { NotificationRepository } from '@/domains/notification/notification.repository';

export class GetNotificationsUseCase {
  private repository: NotificationRepository;

  constructor(repository: NotificationRepository) {
    this.repository = repository;
  }

  async execute(cod_funcionario: number): Promise<NotificationApiResponse> {
    return await this.repository.getNotifications(cod_funcionario);
  }
}
